<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="ml-2 elevation-0 normal-btn-text rounded-tag-small">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="criarCompra" :disabled="!hasModuleGerencia">
        <v-list-item-icon>
          <v-icon>mdi-shopping</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Criar compra</v-list-item-content>
      </v-list-item>
      <v-list-item @click="finalizar" :disabled="!hasModuleGerencia">
        <v-list-item-icon>
          <v-icon>mdi-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Finalizar requisição</v-list-item-content>
      </v-list-item>
      <v-list-item @click="cancelar">
        <v-list-item-icon>
          <v-icon>mdi-close</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Cancelar requisição</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';

export default {
  props: {
    requisicao: Object,
    hasModuleGerencia: Boolean,
  },
  methods: {
    finalizar() {
      RequisicoesService.finalizar(this.requisicao.id)
        .then(() => {
          this.emitUpdate();
        });
    },
    cancelar() {
      RequisicoesService.cancelar(this.requisicao.id)
        .then(() => {
          this.emitUpdate();
        });
    },
    criarCompra() {
      this.$router.push({
        name: 'main.compras.requisicao-compra',
        query: {
          idRequisicao: this.requisicao.id,
        },
        params: {
          isRascunho: false,
        },
      });
    },
    goToEdit() {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: this.requisicao.id,
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
};
</script>
